import {SODeleteProcessStepAssociation} from '../../core/process-step-association/so-delete-process-step-association';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteProcessStepAssociation extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteProcessStepAssociation;
}